import React, { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom'
import Home from './Home/Home'
import Profile from './Profile/Profile'
import View from './View/View'
import './App.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>
          <a href="/">SelectBook</a>
        </h1>
        <hr />
      </header>
      <div className="App-body">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path=":uid" element={<Profile />} />
            <Route path=":uid/:id" element={<View />} />
          </Routes>
        </BrowserRouter>
      </div>
      <footer className="App-footer">
        <hr />
        <h3>
          <a href="https://literate-hawk-153.notion.site/SelectBook-e6ba40c30de04375812ddc3d104aeed9">
            利用規約
          </a>
          <span>Copyright ©Select Inc.</span>
        </h3>
      </footer>
    </div>
  )
}

export default App
